import { useParams, useNavigate, Link } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { hizmetler } from '@/mocks/hizmetler';
import DetayHero from './components/DetayHero';
import DetayIcerik from './components/DetayIcerik';

export default function HizmetDetayPage() {
  const { slug } = useParams<{ slug: string }>();
  const navigate = useNavigate();
  const [mobileMenu, setMobileMenu] = useState(false);

  const hizmet = hizmetler.find((h) => h.slug === slug);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);

  if (!hizmet) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center" style={{ background: '#1A0F0A', fontFamily: "'Inter', sans-serif" }}>
        <link href="https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@1,800&family=Inter:wght@300;400;500&display=swap" rel="stylesheet" />
        <p className="text-white/50 text-lg mb-4">Hizmet bulunamadı.</p>
        <button
          onClick={() => navigate('/hizmetler')}
          className="text-[#1A0F0A] px-6 py-2.5 rounded-full text-sm font-black cursor-pointer"
          style={{ background: 'linear-gradient(135deg, #C9943A, #E8B86D)' }}
        >
          Tüm Hizmetlere Dön
        </button>
      </div>
    );
  }

  return (
    <div className="min-h-screen" style={{ background: '#1A0F0A', fontFamily: "'Inter', sans-serif" }}>
      <link
        href="https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,700;0,800;1,700;1,800&family=Inter:wght@300;400;500;600;700&display=swap"
        rel="stylesheet"
      />

      {/* Navbar */}
      <nav className="fixed top-0 left-0 right-0 z-50 border-b border-white/10"
        style={{ background: 'rgba(26,15,10,0.95)', backdropFilter: 'blur(16px)' }}>
        <div className="max-w-7xl mx-auto px-6 md:px-10 flex items-center justify-between h-[68px]">
          <Link to="/" className="flex items-center gap-2 cursor-pointer">
            <img
              src="https://public.readdy.ai/ai/img_res/a5d1b8cb-aaa2-4cf9-95cd-76f3854cad51.png"
              alt="Elora Beauty Lounge"
              className="h-9 w-auto object-contain"
            />
          </Link>
          <div className="hidden md:flex items-center gap-7">
            <Link to="/" className="text-sm text-white/60 hover:text-[#E8B86D] transition-colors">Ana Sayfa</Link>
            <Link to="/hizmetler" className="text-sm text-[#E8B86D] font-semibold relative after:absolute after:bottom-[-4px] after:left-0 after:right-0 after:h-px after:bg-[#E8B86D]">Hizmetler</Link>
            <Link to="/#kampanyalar" className="text-sm text-white/60 hover:text-[#E8B86D] transition-colors">Kampanyalar</Link>
            <Link to="/#final-cta" className="text-sm text-white/60 hover:text-[#E8B86D] transition-colors">İletişim</Link>
          </div>
          <div className="flex items-center gap-3">
            <a
              href="https://wa.me/905001234567"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#1A0F0A] text-sm font-black px-5 py-2.5 rounded-full transition-all duration-200 whitespace-nowrap hidden md:block"
              style={{ background: 'linear-gradient(135deg, #C9943A, #E8B86D)' }}
            >
              Randevu Al
            </a>
            <button
              className="md:hidden w-9 h-9 flex items-center justify-center text-white/70 cursor-pointer"
              onClick={() => setMobileMenu(!mobileMenu)}
            >
              <i className={mobileMenu ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'}></i>
            </button>
          </div>
        </div>
        {mobileMenu && (
          <div className="md:hidden border-t border-white/10 px-6 py-4 space-y-3"
            style={{ background: 'rgba(26,15,10,0.98)' }}>
            <Link to="/" className="block text-sm text-white/70 py-2" onClick={() => setMobileMenu(false)}>Ana Sayfa</Link>
            <Link to="/hizmetler" className="block text-sm text-[#E8B86D] font-semibold py-2" onClick={() => setMobileMenu(false)}>Hizmetler</Link>
            <Link to="/#kampanyalar" className="block text-sm text-white/70 py-2" onClick={() => setMobileMenu(false)}>Kampanyalar</Link>
            <Link to="/#final-cta" className="block text-sm text-white/70 py-2" onClick={() => setMobileMenu(false)}>İletişim</Link>
          </div>
        )}
      </nav>

      {/* Hero */}
      <DetayHero hizmet={hizmet} />

      {/* Breadcrumb */}
      <div className="max-w-5xl mx-auto px-6 md:px-10 py-4">
        <div className="flex items-center gap-2 text-xs text-white/30">
          <Link to="/" className="hover:text-[#E8B86D] transition-colors">Ana Sayfa</Link>
          <i className="ri-arrow-right-s-line"></i>
          <Link to="/hizmetler" className="hover:text-[#E8B86D] transition-colors">Hizmetler</Link>
          <i className="ri-arrow-right-s-line"></i>
          <span className="text-[#E8B86D]/70 font-medium">{hizmet.baslik}</span>
        </div>
      </div>

      {/* İçerik */}
      <DetayIcerik hizmet={hizmet} />

      {/* Diğer Hizmetler */}
      <div className="py-12 px-6 border-t border-white/10" style={{ background: 'rgba(255,255,255,0.03)' }}>
        <div className="max-w-5xl mx-auto">
          <h2
            className="font-black italic text-white mb-6 leading-tight"
            style={{ fontFamily: "'Playfair Display', serif", fontSize: '1.6rem' }}
          >
            Diğer{' '}
            <span style={{ background: 'linear-gradient(135deg, #C9943A, #E8B86D)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text' }}>
              Hizmetlerimiz
            </span>
          </h2>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {hizmetler
              .filter((h) => h.slug !== slug)
              .slice(0, 4)
              .map((h) => (
                <Link
                  key={h.id}
                  to={`/hizmetler/${h.slug}`}
                  className="group block rounded-xl overflow-hidden border border-white/10 hover:border-[#E8B86D]/35 transition-all"
                  style={{ background: 'rgba(255,255,255,0.04)' }}
                >
                  <div className="h-28 overflow-hidden">
                    <img
                      src={h.gorsel}
                      alt={h.baslik}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    />
                  </div>
                  <div className="p-3">
                    <p className="text-white/80 text-xs font-semibold line-clamp-2 group-hover:text-[#E8B86D] transition-colors">
                      {h.baslik}
                    </p>
                    <p className="text-[#E8B86D] text-xs font-black mt-1">{h.fiyat}</p>
                  </div>
                </Link>
              ))}
          </div>
        </div>
      </div>

      {/* Footer mini */}
      <div className="py-5 px-6 text-center border-t border-white/10">
        <p className="text-white/25 text-xs">
          © 2024 Elora Beauty Lounge — Tüm hakları saklıdır.
        </p>
      </div>
    </div>
  );
}
